export function normalizeMassiveImportErrors (errors = []) {
  if (!Array.isArray(errors)) return []

  return errors.map((item) => ({
    message: item?.message || '',
    error: item?.error || ''
  }))
}
